  const API_ENDPOINT='https://apialumni.infa-formation.com';


export default API_ENDPOINT;
  
